<template>
  <div class="chat-email-funnel d-flex flex-wrap align-center ga-3">
    <v-btn
      color="primary"
      rounded="lg"
      :disabled="busy"
      @click="emit('confirm', { enabled: true })"
    >
      {{ t('onboarding.wizard.chat-widgets.email-funnel-activate') }}
    </v-btn>
    <button
      type="button"
      class="chat-email-funnel__skip text-caption font-weight-bold text-primary"
      :disabled="busy"
      @click="emit('confirm', { enabled: false })"
    >
      {{ t('onboarding.wizard.chat-widgets.email-funnel-skip') }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps<{
  busy?: boolean
}>()

const emit = defineEmits<{
  confirm: [payload: { enabled: boolean }]
}>()

const { t } = useI18n()
</script>

<style scoped>
.chat-email-funnel__skip {
  background: none;
  border: none;
  cursor: pointer;
  letter-spacing: 0.04em;
}
</style>
